import script from "./inventoryItemForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./inventoryItemForm.vue?vue&type=script&setup=true&lang=ts"

import "./inventoryItemForm.vue?vue&type=style&index=0&id=22555750&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22555750"]])

export default __exports__